import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Mutation from './Components/Mutation';
import Mutate from './Components/Mutate';

import "./App.css"

function App() {
  return (
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Mutate />} />
        <Route path="/mutate" element={<Mutate />} />
        <Route path="/mutation" element={<Mutation />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
  );
}
export default App;